import { Component } from "react";
import Logo from '../resources/logo-icon.png';
import SliderButtonn from '../../components/layout/SliderButton';

class header extends Component {

    render() {

        const { handleToogleSideBar } = this.props;
        return (
            <div className="fixed w-full py-4 px-2 border-b border-gray-300 bg-white text-text z-40">
                {/* <div id="titleBrand" className="hideSideEl flex-none w-60 flex flex-row items-center">
                </div> */}
                <div id="navbar" className="flex-1 pl-3 flex flex-row flex-wrap items-center ml-2 ">
                    <div className="md:flex md:justify-evenly">
                        <SliderButtonn handleToogleSideBar={handleToogleSideBar} />
                    </div>
                    <div className="w-60 ml-12">
                        <img src={Logo} height="100px" width="100px" alt="logo" />
                    </div>
                </div>
            </div>
        )
    }
}

export default header;